'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faPrint = require('@fortawesome/fontawesome-free-solid/faPrint');
var _faPrint2 = _interopRequireDefault(_faPrint);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Print = function Print() {
  return _react2.default.createElement('button', {
    onClick: function onClick() {
      return window.print();
    },
    className: 'social__btn social__btn--print',
    title: 'print',
    role: 'link',
    'aria-label': 'Print'
  }, _react2.default.createElement('span', {
    className: 'social__icon social__icon--print'
  }, _react2.default.createElement(_reactFontawesome2.default, {
    icon: _faPrint2.default
  })));
};
exports.default = Print;